<template>
  <div class="markdown-editor">
    <form-group
      :label="label"
      :errors="internalErrors"
      @focus="focus"
    >
      <div class="uk-margin">
        <div class="uk-grid-match uk-child-width-1-2@s" uk-grid>
          <div>
            <textarea
              ref="primaryInput"
              class="uk-textarea"
              :class="inputCss"
              :value="internalValue"
              :disabled="disabled"
              :placeholder="placeholder"
              :rows="rows"
              @input="onInput"
            ></textarea>
          </div>
          <div>
            <div
              class="preview uk-background-muted uk-padding-small"
              v-html="compiledMarkdown"
            ></div>
          </div>
        </div>
      </div>
    </form-group>
    <markdown-quick-reference />
  </div>
</template>

<script>
import { debounce } from 'lodash';
import marked from 'marked';
import Input from '@/mixins/Input';
import TextareaInput from '@/components/TextareaInput';
import MarkdownQuickReference from '@/components/MarkdownQuickReference';

export default {
  name: 'markdown-editor',
  components: {
    TextareaInput,
    MarkdownQuickReference,
  },
  mixins: [Input],
  computed: {
    compiledMarkdown() {
      if (!this.internalValue) return '';
      return marked(this.internalValue, { sanitize: true });
    },
  },
  methods: {
    update() {
      debounce((e) => {
        this.input = e.target.value;
      }, 300);
    },
  },
  props: {
    value: {
      type: String,
      default: '',
    },
    rows: {
      type: [Number, String],
      default: 10,
    },
    placeholder: String,
  },
};
</script>



// WEBPACK FOOTER //
// MarkdownEditor.vue?064070e9